module.exports = __webpack_public_path__ + "static/media/drum-steelpan.4ad97cdb.svg";